import { render } from "./wage-block-dificulty-level.vue?vue&type=template&id=4bde5bc8"
import script from "./wage-block-dificulty-level.vue?vue&type=script&lang=js"
export * from "./wage-block-dificulty-level.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-block-dificulty-level.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bde5bc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bde5bc8', __exports__)) {
    api.reload('4bde5bc8', __exports__)
  }
  
  module.hot.accept("./wage-block-dificulty-level.vue?vue&type=template&id=4bde5bc8", () => {
    api.rerender('4bde5bc8', render)
  })

}


export default __exports__